export const T = {
  en_GB: {
    displayOptions: "Display Options",
    displayDesc: "Choose how this chart is displayed",
    showChart: "Show Chart",
    showChartDesc: "Display the chart",
    timeRanges: "Time Ranges",
    timeRangesDesc: "Which views can be toggled between",
    defaultHorizon: "Default Time Range",
    defaultHorizonDesc: "Which range the chart opens on",
    horizon1Y: "1 year (quarterly)",
    horizon5Y: "5 years",
    horizon10Y: "10 years",
    atLeastOneRange: "At least one time range must be selected",
    showTable: "Show data table",
    atLeastOneOption: "At least one display option must be selected",
    /** What the data table shows, per chart. */
    tableDescription: {
      asset_class_forecast: "Display the asset class table below the chart",
      volatility_chart: "Display volatility values in a table below the chart",
      equity_share_chart:
        "Display the equity, non-equity and unknown shares in a table below the chart",
    },
  },
  nb_NO: {
    displayOptions: "Visningsalternativer",
    displayDesc: "Velg hvordan diagrammet skal vises",
    showChart: "Vis diagram",
    showChartDesc: "Vis diagrammet",
    timeRanges: "Tidsrom",
    timeRangesDesc: "Hvilke visninger det kan veksles mellom",
    defaultHorizon: "Standard tidsrom",
    defaultHorizonDesc: "Hvilket tidsrom diagrammet åpnes med",
    horizon1Y: "1 år (kvartalsvis)",
    horizon5Y: "5 år",
    horizon10Y: "10 år",
    atLeastOneRange: "Minst ett tidsrom må velges",
    showTable: "Vis datatabell",
    atLeastOneOption: "Minst ett visningsalternativ må velges",
    tableDescription: {
      asset_class_forecast: "Vis aktivaklassetabellen under diagrammet",
      volatility_chart: "Vis volatilitetsverdier i en tabell under diagrammet",
      equity_share_chart: "Vis aksje-, ikke-aksje- og ukjent-andelene i en tabell under diagrammet",
    },
  },
} as const;
